<template>
  <div class="the-navbar__theme-mode flex items-center">
    <vx-tooltip :text="themeMode === 'dark' ? 'Light Mode' : 'Dark Mode'" position="bottom">
      <feather-icon
        :icon="themeMode === 'dark' ? 'SunIcon' : 'MoonIcon'"
        class="cursor-pointer mt-1 sm:mr-6 mr-2"
        :svgClasses="['stroke-current', 'h-6', 'w-6', themeMode === 'dark' ? 'text-warning' : '']"
        @click="toggleTheme"
      />
    </vx-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ThemeModeSwitch',
  computed: {
    themeMode () {
      return this.$store.state.theme
    }
  },
  methods: {
    toggleTheme () {
      const nextTheme = this.themeMode === 'dark' ? 'light' : 'dark'
      this.$store.dispatch('updateTheme', nextTheme)
    }
  }
}
</script>
